<template>
    <div class="mobile-nav grid grid__base" :class="rootFacets">
        <mobile-navbar
                class="mobile-nav--navbar mobile-nav--navbr__spacer"
                :class="fixedNavbarClass"
                :is-menu-open="overlayActive"
                @toggle="toggleMobilePanel">
            <img slot="brand-logo"
                    :alt="brandLogoAlt"
                    :src="'img/im-logo-desktop-black.svg'|staticPath">
            <base-icon symbol="burger"
                    size="large"
                    slot="toggle-icon"/>
        </mobile-navbar>


        <scroll-reveal element-class="reduced-nav"
                class="mobile-nav--scroll-reveal"
                :offset="160"
                @onPin="onPin"
                @onUnPin="onUnPin">
            <mobile-navbar
                    :facets="mobileNavbarFacets"
                    :is-menu-open="overlayActive"
                    @toggle="toggleMobilePanel">
                <img
                        v-if="overlayActive"
                        slot="brand-logo"
                        :alt="brandLogoAlt"
                        :src="'img/im-logo-desktop-white.svg'|staticPath">
                <img
                        v-else
                        slot="brand-logo"
                        :alt="brandLogoAlt"
                        :src="'img/im-logo-desktop-black.svg'|staticPath">

                <base-icon symbol="close"
                        size="large"
                        v-if="overlayActive"
                        slot="toggle-icon"/>

                <base-icon symbol="burger"
                        size="large"
                        v-else
                        slot="toggle-icon"/>
            </mobile-navbar>
        </scroll-reveal>
    </div>
</template>

<script>

    import { mapActions, mapGetters, mapState } from 'vuex';
    import MobileNavbar from 'framework/components/navigation/mobile-navbar/mobile-navbar';

    import bemMixin from 'framework/mixins/bem';
    import ScrollReveal from 'framework/components/scroll-reveal/scroll-reveal';

    export default {
        components: { ScrollReveal, MobileNavbar },
        mixins: [bemMixin('mobile-nav')],
        props: {
            /** @type {INavigationEntry[]} */
            items: {
                type: Array,
                required: true,
            },

            brandLogoAlt: {
                type: String,
                required: true,
            },
        },


        data() {
            return {
                overlayId: null,
            };
        },

        computed: {
            ...mapGetters('overlay', ['isOverlayActive']),
            ...mapState('navigation', ['reducedNavVisibility']),

            overlayActive() {
                return this.isOverlayActive(this.overlayId);
            },

            mobileNavbarFacets() {
                return [
                    this.overlayActive ? 'dark' : null,
                ];
            },

            rootFacets() {
                return [
                    this.bemAdd(this.isOverlayActive(this.overlayId) ? 'overlay-active' : 'base'),
                ];
            },

            fixedNavbarClass() {
                if (this.reducedNavVisibility) {
                    return this.bemAdd('reveal-visible', 'navbar');
                }
                return null;
            },
        },

        methods: {
            ...mapActions('overlay', ['registerOverlay', 'openOverlay', 'closeOverlay']),
            ...mapActions('navigation', ['setReducedNavVisibility']),
            ...mapActions('scroll', ['disableScroll']),

            onPin() {
                this.setReducedNavVisibility({ isVisible: true });
            },

            onUnPin() {
                this.setReducedNavVisibility({ isVisible: false });
            },

            toggleMobilePanel() {
                if (this.overlayActive) {
                    this.closeOverlay({ id: this.overlayId });
                } else {
                    this.openOverlay({ id: this.overlayId });
                }
            },
        },
        watch: {
            overlayActive(isActive) {
                this.disableScroll({ isLocked: isActive });
            },
        },

        mounted() {
            this.registerOverlay({
                component: 'dyn-side-nav-panel',
                items: this.items,
                metaNav: this.metaNav,
                backgroundClosable: true,
            })
                .then((overlayId) => {
                    this.overlayId = overlayId;
            });
        },
    };
</script>
